import { render } from "./ChangeUserPassword.vue?vue&type=template&id=4484d4fd&scoped=true"
import script from "./ChangeUserPassword.vue?vue&type=script&lang=js"
export * from "./ChangeUserPassword.vue?vue&type=script&lang=js"

import "./ChangeUserPassword.vue?vue&type=style&index=0&id=4484d4fd&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4484d4fd"]])

export default __exports__